import topHeader from '@/components/topHeader.vue'
import bottomFooter from '@/components/btmFooter.vue'
export default {
    register(app){
        app.component('top-header', topHeader);
        app.component('bottom-footer', bottomFooter);
    }
 }